import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assests/css/admin/CustomerManagement/OrderHistoryModal/OrderHistoryModal.css';

const OrderHistoryModal = ({ isOpen, onClose, customer }) => {
  const { baseUrl } = useContext(AppContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && customer?.id) {
      fetchOrders();
    }
  }, [isOpen, customer]);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/admin/customers/getOrders/${customer.id}`);
      setOrders(response.data.data || []);
    } catch (error) {
      console.log(error);
      setOrders([]);
    }
    setLoading(false);
  };

  if (!isOpen || !customer) return null;

  return (
    <div className="orders-modal-overlay">
      <div className="orders-modal-content">
        <div className="orders-modal-header">
          <div>
            <h2 className="orders-modal-title">Order History</h2>
            <p className="orders-modal-subtitle">
              {customer.firstname} {customer.lastname}
            </p>
          </div>
          <button className="orders-modal-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="orders-list">
          {loading ? (
            <p style={{ textAlign: 'center', padding: '20px' }}>Loading...</p>
          ) : orders.length > 0 ? (
            orders.map(order => (
              <div key={order.id} className="order-item">
                <div className="order-info">
                  <h4 className="order-id">#{order.id}</h4>
                  <p className="order-date">{new Date(order.created_at).toLocaleDateString()}</p>
                </div>
                <div className="order-amount">
                  <p className="order-price">Rs. {order.total}</p>
                  <span className={`order-status order-status-${order.status?.toLowerCase()}`}>
                    {order.status || "Pending"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: 'center', padding: '20px' }}>No Orders Found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryModal;